import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import JunagoLogo from "../components/JunagoLogo";
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post(`/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Une erreur est survenue, réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-sm w-full">
        <Link to="/" className="inline-block mb-10"><JunagoLogo size={34} tone="dark" /></Link>
        {sent ? (
          <div data-testid="forgot-success">
            <div className="h-12 w-12 rounded-2xl bg-emerald-50 flex items-center justify-center">
              <CheckCircle2 className="h-6 w-6 text-emerald-600" />
            </div>
            <h1 className="mt-5 font-heading text-2xl font-medium tracking-tight text-slate-900">Email envoyé</h1>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">
              Si un compte existe avec <strong>{email}</strong>, vous recevrez un lien de réinitialisation valable 1 heure. Pensez à vérifier vos spams.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-violet-600 hover:text-violet-800" data-testid="back-to-login">
              <ArrowLeft className="h-4 w-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-3xl font-medium tracking-tight text-slate-900" data-testid="forgot-title">
              Mot de passe oublié ?
            </h1>
            <p className="mt-2 text-sm text-slate-500 leading-relaxed">
              Entrez votre email : nous vous enverrons un lien pour choisir un nouveau mot de passe.
            </p>
            <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="forgot-form">
              <div>
                <label className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500">Email</label>
                <div className="mt-1.5 relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full rounded-xl border border-slate-200 pl-10 pr-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-violet-600 focus:border-violet-600"
                    placeholder="vous@exemple.com"
                    data-testid="forgot-email"
                  />
                </div>
              </div>
              {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-4 py-3" data-testid="forgot-error">{error}</div>}
              <button type="submit" disabled={loading} className="w-full h-11 inline-flex items-center justify-center gap-2 rounded-full btn-primary font-semibold text-sm disabled:opacity-50" data-testid="forgot-submit">
                {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                Envoyer le lien
              </button>
            </form>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900" data-testid="back-to-login">
              <ArrowLeft className="h-4 w-4" /> Retour à la connexion
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
